import React from 'react';
import JsonView from './JsonView';
import Util from '../Util';
import $ from 'jquery';
import * as actions from '../redux/actions';

const serverList = [
  { name: 'test3', url: 'http://10.10.80.105:9000' },
  { name: 'test4', url: 'http://10.10.80.42:9000' },
  { name: 'lab2', url: 'http://10.10.80.101:9000' },
  { name: 'prod', url: 'http://192.168.61.12:8080' },
];

class SheldonSetup extends React.Component {
  constructor(props) {
    super(props);

    let { hostInfo } = this.props;
    let currentServerName = 'test4';
    let kioskServer = serverList.find((server) => server.url === hostInfo.kskcfgServerUrl);
    if (kioskServer) {
      currentServerName = kioskServer.name;
    }

    this.state = {
      kioskName: '',
      type: '',
      path: '',
      content: '',
      kskapiUrl: 'http://localhost:8188', // for "host" value in capui/settings.json
      selectedServerName: currentServerName,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSetupNewKiosk = this.handleSetupNewKiosk.bind(this);
    this.handleUpdaterServerUrl = this.handleUpdaterServerUrl.bind(this);
  }

  componentDidMount() {
    this.handleType('capui/settings.json');
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleUpdaterServerUrl(event) {
    event && event.preventDefault();

    let { hostInfo, dispatch } = this.props;
    let { ip, authType, fingerprint } = hostInfo;
    let { selectedServerName } = this.state;

    if (
      !window.confirm(
        `Change kiosk to "${selectedServerName}" environment/server and restart kskapi?`
      )
    ) {
      return;
    }

    this.handleType('update-serverurl');
  }

  handleSetupNewKiosk(event) {
    event && event.preventDefault();

    let { kioskName } = this.state;
    let { hostInfo, dispatch, onKioskNameChanged } = this.props;
    let { ip, authType, fingerprint } = hostInfo;

    if (!kioskName) {
      alert('Kiosk name is empty!');
      return;
    }

    if (!window.confirm(`Setup kiosk name "${kioskName}" for ${ip}?`)) {
      return;
    }

    return this.handleType('newkiosk').then(() => {
      this.handleType('ksk/info');
      // fetch using ip address for MQ kiosk type
      dispatch(actions.fetchInfoByIP(ip, authType, fingerprint)).then((hostInfo) => {
        onKioskNameChanged(hostInfo);
      });
    });
  }

  handleType(type, event) {
    event && event.preventDefault();

    let { hostInfo } = this.props;
    let { ip } = hostInfo;
    let { selectedServerName, kioskName, kskapiUrl } = this.state;

    if (this.unmounted) return;

    if (!Util.isValidIpAddress(ip)) {
      return;
    }

    // let kskapi = Util.getKskApiPath(hostInfo);
    // let capui = Util.getCapUIPath(hostInfo);

    // For changing kiosk name we assume we have direct access to kiosk using ip address
    // to workaround capui/settings proxy problem that goes through tally for V5_MQ kiosk type
    let kskapi = Util.getDirectKskApiPath(hostInfo);
    let capui = Util.getDirectCapUIPath(hostInfo);
    let linuxdash = Util.getDirectLinuxDashPath(hostInfo);

    let path = '';
    let data;
    let method = 'GET';
    let timeout = 30000;
    let responseType = 'json';

    let settingsData = {};
    settingsData.host = kskapiUrl;
    settingsData.device = kioskName;
    // settingsData.repo = `http://192.168.61.12`; // git remote repo for capui
    settingsData.env = 'prod';
    settingsData.port = '3000'; // capui port
    settingsData.ipaddr = ip;

    switch (type) {
      case 'newkiosk':
        method = 'POST';
        path = `${capui}/settings`;
        data = settingsData;
        break;
      case 'update-serverurl':
        method = 'POST';
        path =
          `${linuxdash}/exec/kiosk-updater.sh?args=` +
          encodeURIComponent('--switch-kiosk-env=' + selectedServerName);
        responseType = 'text';
        break;
      case 'kskapi-restart':
        method = 'POST';
        path = `${linuxdash}/exec/service?args=kskapi%20restart`;
        responseType = 'text';
        break;
      case 'ksk/info':
        path = `${kskapi}/ksk/info`;
        break;
      case 'capui/settings.json':
        path = `${capui}/settings.json`;
        break;
    }

    if (this.inProgress) {
      this.setState({
        content: (
          <div>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <div>Request in Progress!</div>
          </div>
        ),
      });
      return; // stop when other request in progress
    }

    this.setState({
      type: type,
      path: path,
      content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
    });

    this.inProgress = true;

    return $.ajax({url: path,
      data: data,
      dataType: 'json',
      method: method,
      timeout: timeout,
    })
      .always((arg) => {
        // console.log('always:', arg);
        this.inProgress = false;
      })
      .done((data) => {
        // console.log('done:', data);
        if (responseType === 'json') {
          if (typeof data === 'string') {
            try {
              data = JSON.parse(data);
            } catch (e) {
              console.warn(e);
            }
          }
          this.setState(
            {
              content: <JsonView title={path} data={data} />,
            },
            () => {
              // let $content = $(this.refs.content);
              // $content.scrollTop($content[0].scrollHeight); // scroll to bottom
            }
          );
        } else {
          this.setState({
            content: <pre style={{ color: '' }}>{data}</pre>,
          });
        }
      })
      .fail((jqXHR) => {
        // console.log('fail:', jqXHR);
        this.setState({
          content: <pre style={{ color: '' }}>{jqXHR.responseText}</pre>,
        });
      });
  }

  // https://facebook.github.io/react/docs/forms.html
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // console.log('handleInputChange', name, value);
    this.setState({
      [name]: value,
    });
  }

  render() {
    let { panelHeight } = this.props;
    let { kioskName, type, kskapiUrl, selectedServerName } = this.state;

    return (
      <div className='sheldon-content-wrapper'>
        <h2>Remote Setup</h2>
        <div style={{ margin: '20px 0' }}>
          For changing existing kiosk to a different name or pointing kiosk to a different server
          during testing.
        </div>
        <div className='sheldon-buttons'>
          <form className='pure-u-1-2 pure-form pure-form-stacked'>
            <fieldset>
              <label>Server</label>
              <select
                className='pure-input-2-3'
                name='selectedServerName'
                value={selectedServerName}
                onChange={this.handleInputChange}
              >
                {serverList.map((server) => (
                  <option key={server.name} value={server.name}>
                    {server.name} - {server.url}
                  </option>
                ))}
              </select>
              <button
                className='pure-input-1-5 pure-button pure-button-primary'
                type='button'
                style={{ marginBottom: 30 }}
                onClick={this.handleUpdaterServerUrl}
              >
                Change Server
              </button>

{/*
              <label>kskapi URL (host): </label>
              <input className="pure-input-2-3" style={{marginRight: 5}}
                     type="text"
                     placeholder="http://<host>:8188"
                     name="kskapiUrl"
                     value={kskapiUrl}
                     onChange={this.handleInputChange}
              />
*/}

              <label>Kiosk Name (device name): </label>
              <input
                className='pure-input-2-3'
                style={{ marginRight: 5 }}
                type='text'
                placeholder='e.g. VSH123456'
                name='kioskName'
                value={kioskName}
                onChange={this.handleInputChange}
                autoFocus={true}
              />
              <button
                className='pure-input-1-5 pure-button pure-button-primary'
                type='button'
                onClick={this.handleSetupNewKiosk}
              >
                Change Kiosk
              </button>
            </fieldset>
          </form>
          <div className='pure-u-1-2'>
            <span style={{ paddingRight: 10 }}>View Info:</span>
            <button
              className={type === 'ksk/info' ? 'pure-button pure-button__selected' : 'pure-button'}
              onClick={this.handleType.bind(this, 'ksk/info')}
            >
              ksk/info
            </button>
            <button
              className={
                type === 'capui/settings.json' ? 'pure-button pure-button__selected' : 'pure-button'
              }
              onClick={this.handleType.bind(this, 'capui/settings.json')}
            >
              capui/settings.json
            </button>
          </div>
        </div>
        <div className='sheldon-content'>
          <div style={{ height: panelHeight - 480, overflow: 'auto' }} ref='content'>
            {this.state.content}
          </div>
        </div>
      </div>
    );
  }
}

export default SheldonSetup;



// WEBPACK FOOTER //
// ./src/components/SheldonSetup.js